/* import __COLOCATED_TEMPLATE__ from './topic-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    topic: string;
    subtopics: string[];
    isCompleted: boolean;
  };
}

const TopicStamp = templateOnlyComponent<Signature>();
export default TopicStamp;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::TopicStamp': typeof TopicStamp;
  }
}
